<template>
  <base-dialog
    @on-close="closeDialog"
    @on-sure="sureDialog"
    :title="title"
    :width="width"
    :append-to-body="true"
  >
    <div class="company-switch-select-dialog">
      <div class="main">
        <div>
          <el-radio v-model="radio" label="1">原公司</el-radio>
        </div>
        <div class="center-align">
          <el-radio v-model="radio" label="2">代理公司</el-radio>
          <el-select
            v-model="agentCompanyId"
            placeholder="代理公司"
            :disabled="radio === '1'"
            size="medium"
          >
            <el-option
              v-for="item in agentCompanyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
  </base-dialog>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import baseDialogMixin from '@/mixins/baseDialogMixin'
import {
  getCompanyByIdApi,
  getBrandListApi,
  getBrandByIdApi,
  getShopListApi,
  getCompanyCustomConfigApi
} from '@/api'
import { RES_OK } from '../../config'
import { isEmpty } from '../../utils'
export default {
  inject: ['reload'],
  props: {
    brandId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      title: '切换公司',
      width: 350,
      radio: '1',
      agentCompanyId: '',
      customConfig: '',
      tempCompanyInfo: '',
      oldCompanyInfo: ''
    }
  },
  mixins: [baseDialogMixin],
  computed: {
    ...mapGetters([
      'agentCompanyList',
      'companyInfo',
      'originCompanyInfo',
      'navList'
    ]),
    companyId() {
      return this.companyInfo.id
    },
    originCompanyId() {
      return this.originCompanyInfo.id
    }
  },
  mounted() {
    if (this.companyId === this.originCompanyId) {
      this.radio = '1'
      this.agentCompanyId = ''
    } else {
      this.radio = '2'
      this.agentCompanyId = this.companyId
    }
    this.oldCompanyInfo = JSON.parse(JSON.stringify(this.companyInfo))
  },
  methods: {
    ...mapActions(['']),
    ...mapMutations([
      'setCompanyInfo',
      'setBrandList',
      'setBrandInfo',
      'setShopList',
      'setShopInfo',
      'setBackMenuConfig',
      'setBackPageConfig',
      'setFrontPageConfig',
      'setBusinessMpPageConfig'
    ]),
    //  获取公司信息
    async getCompanyById(companyId) {
      const param = {}
      param.id = companyId
      const res = await getCompanyByIdApi(param)
      if (res.Code === RES_OK) {
        this.tempCompanyInfo = res.Result
        this.setCompanyInfo(res.Result)
        await this.getCompanyCustomConfig(res.Result.id)
        this.doGetBrandList(res.Result.id)
      }
    },
    async getCompanyCustomConfig(companyId) {
      let param = {}
      param.companyId = companyId
      param.configType = ''
      const res = await getCompanyCustomConfigApi(param)
      if (res.Code === RES_OK) {
        this.customConfig = res.Result || ''
        // if (res.Result) {
        //   this.setBackMenuConfig(res.Result.backMenuConfig || [])
        //   this.setBackPageConfig(res.Result.backPageConfig || [])
        //   this.setFrontPageConfig(res.Result.frontPageConfig || [])
        // } else {
        //   this.setBackMenuConfig([])
        //   this.setBackPageConfig([])
        //   this.setFrontPageConfig([])
        // }
      }
    },
    //  品牌列表
    async doGetBrandList(companyId) {
      const param = {
        companyId: companyId
      }
      const res = await getBrandListApi(param)
      if (res && res.Code === RES_OK) {
        const list = res.Result || []
        this.setBrandList(list)
        if (list.length) {
          this.getBrandById(list[0].id)
          // debugger
          if (!isEmpty(this.customConfig)) {
            this.setBackMenuConfig(this.customConfig.backMenuConfig || [])
            this.setBackPageConfig(this.customConfig.backPageConfig || [])
            this.setFrontPageConfig(this.customConfig.frontPageConfig || [])
            this.setBusinessMpPageConfig(
              this.customConfig.businessMpPageConfig || []
            )
          } else {
            this.setBackMenuConfig([])
            this.setBackPageConfig([])
            this.setFrontPageConfig([])
            this.setBusinessMpPageConfig([])
          }
          this.oldCompanyInfo = JSON.parse(JSON.stringify(this.tempCompanyInfo))
          // dispatch('doGetShopListAction')
        } else {
          let tempCompanyInfo = JSON.parse(JSON.stringify(this.oldCompanyInfo))
          // if (isEmpty(this.oldCompanyInfo)) {
          //   tempCompanyInfo = JSON.parse(JSON.stringify(this.originCompanyInfo))
          // } else {
          //   tempCompanyInfo = JSON.parse(JSON.stringify(this.oldCompanyInfo))
          // }
          this.setCompanyInfo(tempCompanyInfo)
          this.$message.warning('该公司下没有可管理的品牌，请切换公司')
          // this.getCompanyById(this.originCompanyId)
          return
        }
      }
    },
    //  品牌详情
    async getBrandById(brandId) {
      const param = {
        id: brandId
      }
      const res = await getBrandByIdApi(param)
      if (res.Code === RES_OK) {
        const brandInfo = res.Result || {}
        this.setBrandInfo(brandInfo)
        this.doGetShopListAction(brandInfo.id)
      }
    },
    //  门店列表
    async doGetShopListAction(brandId) {
      const param = {
        brandId: brandId
      }
      const res = await getShopListApi(param)
      if (res.Code === RES_OK) {
        const list = res.Result || []
        this.setShopList(list)
        if (list.length > 0) {
          this.setShopInfo(list[0])
        }
      }
      this.$message.success('切换成功')
      this.closeDialog()
      this.$router.push({
        path: this.navList[0].url
      })
      this.$nextTick(() => {
        this.reload()
      })
    },
    sureDialog() {
      if (this.radio === '1') {
        if (this.companyId === this.originCompanyId) {
          this.$message.warning('当前处于该公司，无需切换')
          return
        } else {
          this.getCompanyById(this.originCompanyId)
        }
      } else if (this.radio === '2') {
        if (this.companyId === this.agentCompanyId) {
          this.$message.warning('当前处于该公司，无需切换')
          return
        } else {
          this.getCompanyById(this.agentCompanyId)
        }
      }

      // this.$emit('on-sure')
    },
    closeDialog() {
      this.$emit('on-close')
    }
  }
}
</script>
<style lang="scss">
@import '../../assets/scss/variable.scss';
.el-dialog {
  .el-dialog__body {
    .company-switch-select-dialog {
      padding: 20px;
      .center-align {
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
